import { TypesenseProductsDocument } from 'shared-code/typesense/typesense.types'
import { DSCompareProductPrefetchedInfo, DSVar } from 'shared-definitions/types'
import { compareProductScoreMapper } from './compareProductScoreMapper'

export function compareProductPrefetchedInfoMapper(
  input: TypesenseProductsDocument[],
  histogramMetrics: DSVar<number>[]
): DSCompareProductPrefetchedInfo {
  const product = input[0]
  if (!product) {
    return {
      comparedFeatures: [],
      allProducts: [],
    }
  }

  return {
    comparedFeatures: histogramMetrics.map(metric => ({
      key: metric.value.toString(),
      label: metric.name,
      min: 0,
      max: 10,
    })),
    allProducts: input.map(compareProductScoreMapper),
  }
}
